import fc from "@/firebaseConfig";
// import firebase from "firebase/app";
// import algoliasearch from "algoliasearch";
// import getDocumentTypeKey from "../../libs/getDocumentTypeKey";
// import router from "@/router";
// import gql from "graphql-tag";
// import moment from "moment";
// const _ = require("lodash");

export default{
  namespaced: true,
    state:{
        exchangeRateSettingList: [],
        bankList: [
          {
            code: "BOT",
            name: "Bank of Thailand"
          },
          {
            code: "KBANK",
            name: "Kasikorn Bank"
          },
          {
            code: "SCB",
            name: "Siam Commercial Bank"
          },
          {
            code: "BBL",
            name: "Bangkok Bank"
          },
          {
            code: "KTB",
            name: "Krung Thai Bank"
          },
          {
            code: "UOB",
            name: "United Overseas Bank"
          },
          {
            code: "BCEL",
            name: "Banque pour le Commerce Exterieur Lao Public"
          }
        ],
        fieldType: [],
        dummiesFieldList: {
          "FieldType": {
            "BOT": {
              "BuyingCHQ": "",
              "BuyingEXP": "Sight Bill",
              "BuyingTRN": "Transfer",
              "BuyingNotes": "",
              "SellingCHQ": "",
              "SellingNotes": "Average Selling Rates"
            },
            "KBANK": {
              "BuyingCHQ": "TRAVELLERS' CHEQUES",
              "BuyingEXP": "EXPORT SIGHT BILL",
              "BuyingTRN": "TELEX TRANSFER",
              "BuyingNotes": "BANK NOTES",
              "SellingCHQ": "TT&DRAFT T/CHEQUES",
              "SellingNotes": "BANK NOTES"
            },
            "SCB": {
              "BuyingCHQ": "(BANK BUYS) T/CHQS. & CHQS.",
              "BuyingEXP": "(BANK BUYS) EXPORT SIGHT BILL",
              "BuyingTRN": "(BANK BUYS) TT",
              "BuyingNotes": "(BANK BUYS) NOTES",
              "SellingCHQ": "(BANK SELLS) DD & T/T",
              "SellingNotes": "(BANK SELLS) NOTES"
            },
            "BBL": {
              "BuyingCHQ": "",
              "BuyingEXP": "Sight Bill Buying Rates",
              "BuyingTRN": "TT Buying Rates",
              "BuyingNotes": "Bank Notes Buying Rates",
              "SellingCHQ": "Bill - DD - TT Selling Rates",
              "SellingNotes": "Bank Notes Selling Rates"
            },
            "KTB": {
              "BuyingCHQ": "",
              "BuyingEXP": "(BUYING) SIGHT BILL",
              "BuyingTRN": "(BUYING) T/T",
              "BuyingNotes": "(BUYING) FOREIGN BANK NOTE",
              "SellingCHQ": "(SELLING) T/T",
              "SellingNotes": "(SELLING) FOREIGN BANK NOTE"
            },
            "UOB": {
              "BuyingCHQ": "",
              "BuyingEXP": "(BUY) SIGHT",
              "BuyingTRN": "(BUY) T/T",
              "BuyingNotes": "",
              "SellingCHQ": "",
              "SellingNotes": "SELL"
            },
            "BCEL": {
              "BuyingCHQ": "",
              "BuyingEXP": "(Buy Rates) Bill",
              "BuyingTRN": "(Buy Rates) EFT",
              "BuyingNotes": "(Buy Rates) Note",
              "SellingCHQ": "",
              "SellingNotes": "Sell Rates"
            }
          }
        }
    },
    mutations:{
        setExchangeRateSettingList(state,val){
          state.exchangeRateSettingList = val;
        },
        setFieldType(state,val){
            const fieldNameList = [];
            for (const key in state.dummiesFieldList.FieldType) {
              const value = state.dummiesFieldList.FieldType[key];
              fieldNameList.push({
                bankName: key,
                BuyingCHQ: value.BuyingCHQ,
                BuyingEXP: value.BuyingEXP,
                BuyingTRN: value.BuyingTRN,
                BuyingNotes: value.BuyingNotes,
                SellingCHQ: value.SellingCHQ,
                SellingNotes: value.SellingNotes
              });
            }
            state.fieldType = fieldNameList;
        }
    },
    actions:{
        setExchangeRateSettingList({commit, dispatch}, data){
            commit('setExchangeRateSettingList', data)
            dispatch('getFieldType')
        },
        getFieldType({commit}){
            commit("setFieldType", true)
        },
        getBankFieldListValue({state}, bankName){
          const objList = state.fieldType.find(field => field.bankName === bankName)
          const fieldNameList = [];
          for (const key in objList) {
            if (objList[key] !== "" && key !== "bankName") {
              fieldNameList.push(objList[key]);
            }
          }
          return fieldNameList;
        },
        getFieldByBankAndFieldName({state}, {bankName, fieldName}){
          const objList = state.fieldType.find(field => field.bankName === bankName)
          for (const key in objList) {
            if (objList[key] === fieldName && key !== "bankName" && fieldName !== "") {
              return key;
            }
          }
          throw new Error("Not found field name");
        },
      getFieldValueByBankAndFieldKey({state}, {bankName, fieldKey}) {
        const objList = state.fieldType.find(field => field.bankName === bankName)
        return objList[fieldKey];
      }
    },
    module:{

    }
}
